import { render, staticRenderFns } from "./AcceleratorProfile.vue?vue&type=template&id=edb0e870&"
import script from "./AcceleratorProfile.vue?vue&type=script&lang=js&"
export * from "./AcceleratorProfile.vue?vue&type=script&lang=js&"
import style0 from "./AcceleratorProfile.vue?vue&type=style&index=0&id=edb0e870&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports